import { ADDED, INITIALIZED, UPLOADING, UPLOADED, FAILED } from './actions';

export const getUpload = (state, id) => state.uploads.objects[id];

export const getUploads = (state, status) => {
  if (state.uploads.objects === null) {
    return null;
  }
  if (typeof status === 'undefined') {
    return state.uploads.ids.map((id) => state.uploads.objects[id]);
  }
  return state.uploads.ids
    .map((id) => state.uploads.objects[id])
    .filter((upload) => upload.status === status);
};

export const getAdded = (state) => getUploads(state, ADDED);

export const getInitialized = (state) => getUploads(state, INITIALIZED);

export const getUploading = (state) => getUploads(state, UPLOADING);

export const getUploaded = (state) => getUploads(state, UPLOADED);

export const getFailed = (state) => getUploads(state, FAILED);
